import { useCallback, useEffect, useState } from 'react';

import {
  getProductDemoModeKey,
  productDemoStorage,
} from '~modules/product-demo/product-demo-storage';
import { useGetUser } from '~modules/user/api/hooks/use-get-user';

export const useProductDemoMode = () => {
  const { data: user } = useGetUser();
  const userId = user?.id;

  const readEnabled = useCallback(
    () => productDemoStorage.isEnabled(userId),
    [userId],
  );

  const [isDemoMode, setIsDemoMode] = useState(readEnabled);

  useEffect(() => {
    setIsDemoMode(readEnabled());
  }, [readEnabled]);

  useEffect(() => {
    if (!userId) return;

    const handleStorage = (event: StorageEvent) => {
      if (event.key !== getProductDemoModeKey(userId)) return;

      setIsDemoMode(readEnabled());
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [readEnabled, userId]);

  return {
    isDemoMode,
    userId,
  };
};
